export const EXCEL = 'excel',
  PDF = 'pdf';

export const EXCEL_FORMAT = '.xlsx,.xls,.xlsm',
  PDF_FORMAT = '.pdf';